import {
  CohortBuilderItemChangeStatusLegacy,
  type StudyPeriodRestrictionsLegacy,
} from '@verantos-dev/types-cohorts';

export const checkStudyPeriodRestrictionsStatus = (
  prevStudyPeriodRestrictions: StudyPeriodRestrictionsLegacy | undefined,
  nextStudyPeriodRestrictions: StudyPeriodRestrictionsLegacy | undefined
): CohortBuilderItemChangeStatusLegacy | undefined => {
  const prevBaseline = prevStudyPeriodRestrictions?.baselinePeriodRestriction;
  const nextBaseline = nextStudyPeriodRestrictions?.baselinePeriodRestriction;
  const prevOverall = prevStudyPeriodRestrictions?.overallStudyPeriodRestriction;
  const nextOverall = nextStudyPeriodRestrictions?.overallStudyPeriodRestriction;
  const prevFollowUp = prevStudyPeriodRestrictions?.followUpPeriodRestriction;
  const nextFollowUp = nextStudyPeriodRestrictions?.followUpPeriodRestriction;

  if (!nextBaseline?.isEnabled && !nextOverall?.isEnabled && !nextFollowUp?.isEnabled) {
    return undefined;
  } else if (!prevBaseline && nextBaseline) {
    return CohortBuilderItemChangeStatusLegacy.NEW;
  } else if (!prevFollowUp && nextFollowUp) {
    return CohortBuilderItemChangeStatusLegacy.NEW;
  } else if (!prevOverall && nextOverall) {
    return CohortBuilderItemChangeStatusLegacy.NEW;
  } else if (
    prevBaseline &&
    prevBaseline?.daysBeforeIndexDate !== nextBaseline?.daysBeforeIndexDate
  ) {
    return CohortBuilderItemChangeStatusLegacy.EDITED;
  } else if (prevOverall && prevOverall?.startDate !== nextOverall?.startDate) {
    return CohortBuilderItemChangeStatusLegacy.EDITED;
  } else if (prevOverall && prevOverall?.endDate !== nextOverall?.endDate) {
    return CohortBuilderItemChangeStatusLegacy.EDITED;
  } else if (
    prevFollowUp &&
    prevFollowUp?.daysAfterIndexDate !== nextFollowUp?.daysAfterIndexDate
  ) {
    return CohortBuilderItemChangeStatusLegacy.EDITED;
  } else if (
    prevBaseline &&
    prevBaseline?.daysBeforeIndexDate === nextBaseline?.daysBeforeIndexDate
  ) {
    return CohortBuilderItemChangeStatusLegacy.UNCHANGED;
  } else if (prevOverall && prevOverall?.startDate === nextOverall?.startDate) {
    return CohortBuilderItemChangeStatusLegacy.UNCHANGED;
  } else if (prevOverall && prevOverall?.endDate === nextOverall?.endDate) {
    return CohortBuilderItemChangeStatusLegacy.UNCHANGED;
  } else if (
    prevFollowUp &&
    prevFollowUp?.daysAfterIndexDate === nextFollowUp?.daysAfterIndexDate
  ) {
    return CohortBuilderItemChangeStatusLegacy.UNCHANGED;
  }

  return undefined;
};
